import React from "react";
import Button from "../../../../../components/button/button.jsx";
import { FaPlus, FaTrash } from "react-icons/fa";
import InputForm from "../../../../../components/input/input-form.jsx";
import projectUtils from "../../../../../utils/project-utils.js";
import SelectComponent from "../../../../../components/select/select-component.jsx";

const typeOptions = [
    { value: "CâMERA", label: "Câmera" },
    { value: "IVA", label: "IVA" },
    { value: "DETECTOR DE FUMAÇA", label: "Detector de fumaça" },
    { value: "IVP", label: "IVP" },
    { value: "MAGNÉTICO", label: "Magnético" },
    { value: "BARREIRA", label: "Barreira" },
];

const AlarmSectors = ({ sectors = [], setSectors }) => {
    const normalizeId = (value) => {
        if (!value) return "";

        const clean = value.replace(/\D/g, "");
        return clean.padStart(3, "0");
    };

    const onChangeSector = (index, field, value) => {
        const updated = [...sectors];

        if (field === "id") {
            const newId = normalizeId(value);
            const exists = updated.some((s, i) => s.id === newId && i !== index);

            if (exists) {
                projectUtils.swalMessage("warning", "", "Já existe um setor com esse ID");
                return;
            }

            updated[index].id = newId;
        } else {
            updated[index][field] = value;
        }

        setSectors(updated);
    };

    const addSector = () => {
        setSectors([...sectors, { id: "", name: "" }]);
    };

    const removeSector = (index) => {
        setSectors(sectors.filter((_, i) => i !== index));
    };

    return (
        <div className="mt-4">
            <h4 className="font-semibold mb-3 border-b border-gray-200">
                Setores
            </h4>

            { sectors.map((s, i) => (
                <div key={i} className="grid grid-cols-12 gap-4 mb-3">
                    <InputForm
                        id={`sector_id-${i}`}
                        label="ID *"
                        value={s.id}
                        onChange={(e) => onChangeSector(i, "id", e.target.value)}
                        classNameWrapper="col-span-1"
                    />

                    <SelectComponent
                        label="Tipo *"
                        value={s.type}
                        options={typeOptions}
                        onChange={(opt) => onChangeSector(i, "type", opt.value)}
                        classNameWrapper="col-span-2"
                    />

                    <div className="col-span-9 flex items-end gap-2">
                        <InputForm
                            id={`sector_name-${i}`}
                            label="Nome *"
                            value={s.name}
                            onChange={(e) => onChangeSector(i, "name", e.target.value)
                        }
                            classNameWrapper="flex-1"
                        />

                        <Button target="danger" onClick={() => removeSector(i)}>
                            <FaTrash />
                        </Button>
                    </div>
                </div>
            ))}

            <Button onClick={addSector}>
                <FaPlus /> Adicionar setor
            </Button>
        </div>
    );
};

export default AlarmSectors;